import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs/Rx";
import { Http, RequestOptions, Headers, Response } from "@angular/http";
import { environment } from "../../../../environments/environment";

// Interfaces
import { IService } from "../../interfaces";

// Services
import { LogService } from "../log/log.service";
import { ServerService } from "../server/server.service";

import * as _ from "lodash";

@Injectable()
export class SsoService implements IService {
	// implements local variables
	// Private
	private headers: Headers;
	private BasePath = environment.BaseUrl;
	private ninjaapiendpoint = this.BasePath + "/utils/api/ninja/";

	// map((res: Response) => this.ApplyContext(res)).share();
	private loginurl = this.BasePath + "/SAML/sso.ashx?" + "org=ACEP&redir=";
	private logouturl = `${this.BasePath}/Logout.aspx?redirurl=${
		environment.BaseUrl
	}/${environment.base.name}`;

	// Public
	_data: {
		context: any;
		contactid: string;
		acepid: string;
		firstname: string;
		avatar: string;
	};
	defaultAvatar =
		"https://webapps.acep.org/globalassets/images/defaultavatar.png";
	// implements IService
	name = "SsoService";
	test(name, value) {
		console.log("testing", name, value);
	}

	constructor(
		private _logSrv: LogService,
		private _serverSrv: ServerService
	) {}

	get DATA() {
		if (this._data === undefined) {
			this._data = {
				acepid: "",
				contactid: "",
				context: undefined,
				firstname: "",
				avatar: this.defaultAvatar
			};
		}
		return this._data;
	}

	// Gets the SSO user's context//
	GetSSO(caller: string) {
		"GetSSO caller".logWithObject(this.name, caller);
		try {
			if (this.DATA.context) {
				"inside data context true: ".logWithObject(
					this.name,
					this.DATA.context
				);
				return Promise.resolve(this.DATA.context);
			}
			return this.GetContext(caller);
		} catch (error) {
			"inside getsso errors".logWithObject(this.name, { error, caller });
			return this.GetContext(undefined);
		}
	}

	GetContext = (caller: string) => {
		let options: RequestOptions;

		const headers = new Headers({
			Authorization: environment.Token,
			"Content-Type": "application/json",
			"Access-Control-Allow-Origin": "*"
		});
		options = new RequestOptions({ headers: headers });
		"inside get context".logWithObject(this.name, options);

		const env = environment.Evn;
		if (env === "development") {
			this.ninjaapiendpoint = "http://localhost/acep/utils/api/ninja/";
		}

		return this._serverSrv
			.GetByURL(caller, this.ninjaapiendpoint + "GetContext", options)
			.toPromise()
			.then(res => {
				return this.ApplyContext(res);
			});
	};

	ApplyContext(c: any): Promise<any> {
		"Getting context1".logWithObject(this.name, c);
		//alert('in applycontext');
		c = c.json();
		c.user = JSON.parse(c.user);
		"Getting context2".logWithObject(this.name, c.user);
		if (c.user && c.user.ContactNumber && c.user.ContactNumber.length > 0) {
			c.paymentconfiguration = JSON.parse(c.paymentconfig);
			this.DATA.context = c;
			this.DATA.acepid = c.user.ContactNumber;
			this.DATA.contactid = c.user.ContactId;
			this.DATA.firstname = c.user.FirstName;

			if (this.DATA.context.user.Avatar === "") {
				this.DATA.context.user.Avatar = this.defaultAvatar;
			}
			this.DATA.avatar = this.DATA.context.user.Avatar;
			"returning context".logWithObject(this.name, this.DATA);
			this._logSrv.Info(this.name, ["Signing in", c, c.user]);
			// this._emailService.sendToDev(
			//     c.user.ContactNumber, this.name, 'SSO Sign on').subscribe();
			return this.DATA.context;
		} else {
			this._data = undefined;
			return undefined;
		}
	}

	CheckAuthorizationOnResponse(error) {
		if (error.status === "401") {
			this._data = undefined;
			// Show notification from current app's ui service here : TODO
			// this.notify('Session Expired. You will be redirected to the Login Page', '', 'error');
			alert("Session Expired. You will be redirected to the Login Page");
			this.login("/applications/home");
		}
	}

	/**
	 * let u = url || 'applications/home';
	 * this._ssoService.login(u);
	 * @param returnurl url of where sso will return to
	 */
	login(returnurl: string) {
		// alert(this.contactid);
		if (this.DATA.contactid === "" || this.DATA.contactid === undefined) {
			let url =
				this.loginurl +
				_.escape(
					environment.BaseUrl +
						`/${environment.base.name}/#${returnurl}`
				); //window.location.href);
			console.log("login url is:  " + url);
			window.location.href = url;
			// this.showwait();
			return false;
		}
		return true;
	}

	// logout
	logout() {
		this.logouturl.log("SSO Service is logging out");
		window.location.href = this.logouturl;
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/sso/sso.service.ts